module.exports = "<app-navigation></app-navigation>\r\n"